module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.offered) ? _c('span', {
    staticClass: "usp",
    class: 'usp-' + _vm.variant
  }, [_c('button', {
    staticClass: "usp-open",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openConfirm
    }
  }, [_vm._v("Use your Show Pass on this show")]), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "usp-scrim",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "usp-dlg",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.heading
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), (!_vm.error) ? _c('div', {
    staticClass: "usp-body"
  }, [_c('p', [_vm._v("Everyone on this show will be able to edit it, with or without a subscription.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("If this project is deleted, the Show Pass associated with it will also be deleted. The Show Pass cannot be reapplied.")])]) : _c('div', {
    staticClass: "usp-body"
  }, [_c('p', {
    staticClass: "usp-err",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))])]), _vm._v(" "), _c('div', {
    staticClass: "usp-acts"
  }, [(!_vm.error) ? [_c('button', {
    staticClass: "usp-flat",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "usp-raised",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.busy ? 'Using…' : 'Use Show Pass'))])] : _c('button', {
    staticClass: "usp-raised",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("OK")])], 2)])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("A Show Pass stays on the show it's used on.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00eb09c0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/show-pass/use-show-pass.vue
// module id = 1196
// module chunks = 21